import { Http } from "@/plugins/http.js";
import { cacheKeyFromFilterObject } from "@/core/utils.js";

class References {
  #http;
  #cache = new Map();

  constructor(http) {
    this.#http = http;
  }

  /**
   * @param {Object} filter
   * @param {boolean} filter.forAppointment
   * @return Promise<Reference.ServiceProvidingWay[]>
   */
  serviceProvidingWays(filter = { forAppointment: false }) {
    const cacheKey = cacheKeyFromFilterObject(filter, "serviceProvidingWays");

    if (this.#cache.has(cacheKey)) {
      return this.#cache.get(cacheKey);
    }

    if (filter.forAppointment) {
      const data = [
        {
          id: 1,
          name: "Удалённая консультация",
          short_name: "УД",
        },
        {
          id: 3,
          name: "Очный приём",
          short_name: "ОП",
        },
        {
          id: 4,
          name: "Выезд на дом",
          short_name: "ВД",
        },
      ];
      this.#cache.set(cacheKey, data);
      return data;
    }

    return this.#http
      .get(`v1/references/service-providing-ways`, { params: {} })
      .then(response => {
        this.#cache.set(cacheKey, response.data.data);
        return response.data.data;
      })
      .catch(() => []);
  }

  /**
   * @param {Object} filter
   * @param {boolean} filter.hasDoctors
   * @return Promise<Reference.Clinic[]>
   */
  clinics(filter = { hasDoctors: false }) {
    const cacheKey = cacheKeyFromFilterObject(filter, "clinics");

    if (this.#cache.has(cacheKey)) {
      return this.#cache.get(cacheKey);
    }

    return this.#http
      .get("v1/references/clinics", { params: { has_doctor: filter.hasDoctors } })
      .then(response => {
        this.#cache.set(cacheKey, response.data.data);
        return response.data.data;
      })
      .catch(() => []);
  }

  /**
   * @return Promise<Reference.Service[]>
   */
  services() {
    if (this.#cache.has("services")) {
      return this.#cache.get("services");
    }

    return this.#http
      .get("v1/references/services", { params: { lang: "ru" } })
      .then(response => {
        this.#cache.set("services", response.data.data);
        return response.data.data;
      })
      .catch(() => []);
  }

  /**
   * @return Promise<Reference.Specialization[]>
   */
  specializations() {
    if (this.#cache.has("specializations")) {
      return this.#cache.get("specializations");
    }

    return this.#http
      .get("v1/references/specializations", { params: { lang: "ru" } })
      .then(response => {
        this.#cache.set("specializations", response.data.data);
        return response.data.data;
      })
      .catch(() => []);
  }
}

const ReferencesRepository = new References(Http);

export { ReferencesRepository };
